/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * PG連携会社
 * @export
 * @interface GroupCompany
 */
export interface GroupCompany {
    /**
     * 会社ID
     * @type {string}
     * @memberof GroupCompany
     */
    companyId: string;
}

/**
 * Check if a given object implements the GroupCompany interface.
 */
export function instanceOfGroupCompany(value: object): value is GroupCompany {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function GroupCompanyFromJSON(json: any): GroupCompany {
    return GroupCompanyFromJSONTyped(json, false);
}

export function GroupCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
    };
}

export function GroupCompanyToJSON(json: any): GroupCompany {
    return GroupCompanyToJSONTyped(json, false);
}

export function GroupCompanyToJSONTyped(value?: GroupCompany | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
    };
}

